// test2722
(2722 && 0);
